/* T8 size guide popup outside the PDP (Frame Your Photos on Home + its page): [data-t8-sg-open="<modal id>"] opens the
   matching [data-t8-size-guide] modal; backdrop, × and Escape close it, focus returns to the button.
   The PDP modal (chart + visualiser) is wired by t8-product.js instead. */
(function () {
  if (window.T8SizeGuide) return;
  var last = null;
  function open(modal, btn) {
    last = btn || null;
    modal.hidden = false;
    document.body.classList.add('t8-sg-open');
    var d = modal.querySelector('.t8-sg__dialog'); if (d) d.focus();
  }
  function close(modal) {
    modal.hidden = true;
    if (!document.querySelector('[data-t8-size-guide]:not([hidden])')) document.body.classList.remove('t8-sg-open');
    if (last) { last.focus(); last = null; }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-t8-sg-open]');
    if (btn) {
      var modal = document.getElementById(btn.getAttribute('data-t8-sg-open'));
      if (modal) { e.preventDefault(); open(modal, btn); }
      return;
    }
    var x = e.target.closest('[data-t8-sg-close]');
    if (x) { var m = x.closest('[data-t8-size-guide]'); if (m && !m.closest('[data-t8-pdp]')) close(m); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-t8-size-guide]:not([hidden])').forEach(function (m) { if (!m.closest('[data-t8-pdp]')) close(m); });
  });
  window.T8SizeGuide = { open: open, close: close };
})();
